import { useTheme } from '@doxyme/ui/theme';
import { type CSSObject } from '@emotion/react';

type Return = Record<'container' | 'section' | 'backgroundItem', CSSObject>;

export const useVirtualBackgroundsListStyles = (): Return => {
  const theme = useTheme();
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(6),
      alignSelf: 'stretch',
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(3),
    },
    backgroundItem: {
      display: 'flex',
      alignItems: 'stretch',
      alignContent: 'flex-end',
      gap: theme.spacing(3),
      alignSelf: 'stretch',
      flexWrap: 'wrap',
    },
  };
};
